module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [(!_vm.authorized) ? _c('div', {
    staticClass: "email-input"
  }, [(_vm.isNewDesign) ? _c('input', {
    staticClass: "input",
    attrs: {
      "type": "email",
      "required": "",
      "placeholder": "Enter your email address..."
    },
    domProps: {
      "value": _vm.email
    },
    on: {
      "input": _vm.setEmail
    }
  }) : _c('input', {
    staticClass: "input",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": "Enter secret..."
    },
    domProps: {
      "value": _vm.secret
    },
    on: {
      "input": _vm.setSecret
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button-submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])]) : _vm._e(), _vm._v(" "), (_vm.authorized) ? _c('button', {
    staticClass: "button",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n      Save changes\n    ")]) : _vm._e()]), _vm._v(" "), (_vm.saveSuccess) ? _c('div', [_vm._v("\n    " + _vm._s(_vm.saveSuccess) + "\n  ")]) : _vm._e(), _vm._v(" "), (_vm.saveError) ? _c('div', [_vm._v("\n    " + _vm._s(_vm.saveError) + "\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ee1e386"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/SaveForm.vue
// module id = 572
// module chunks = 1